import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtectInstockProduct.propTypes = {
  children: PropTypes.node
};

const home_url = process.env.REACT_APP_DOMAIN;

function AuthProtectInstockProduct({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();

  let generalAccessList = user.general_access_list;

  console.log('AuthProtect');
  console.log(user);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || !generalAccessList.includes('instockProduct')) {
    window.location = `${home_url}/unauthorized`;
    return <LoadingScreen />;
  }

  return <>{children}</>;
}

export default AuthProtectInstockProduct;
